module.exports = __webpack_public_path__ + "media/images/icons/to-listen-8812f4ea0d44c1f6e2e96b1d9923026f.svg";